module.exports = __webpack_public_path__ + "d4414e39ca77f1db5cf621f0569de31c.svg";